<template>
  <div class="login site__centered">
    <form
      class="form"
      @submit.prevent="submitResetPasswordForm"
    >
      <div class="form__wrap login__form">
        <h2 class="form__title"> Reset Password</h2>
        <p class="form__subtitle">An administrator has updated your account security.
          Please create a new password to continue.</p>
        <label class="form__row">
          <span class="form__row-label">New Password *</span>
          <div class="form__row-pass">
            <input
              v-model="formData.password"
              class="input"
              :type="typePassword"
              placeholder="******"
              :class="{'is-invalid': $v.formData.password.$dirty &&
                            (!$v.formData.password.required || !$v.formData.password.minLength) }"
            />
            <span class="form__row-pass-show" @click="showPassword()">
              {{ typePassword === 'password' ? 'Show' : 'Hide' }}
            </span>
          </div>
        </label>

        <label class="form__row">
          <span class="form__row-label">Confirm Password *</span>
          <div class="form__row-pass">
            <input
              v-model="formData.passwordRepeat"
              class="input"
              :type="typePassword"
              placeholder="******"
              :class="{'is-invalid': $v.formData.passwordRepeat.$dirty &&
                            (!$v.formData.passwordRepeat.required || !$v.formData.passwordRepeat.minLength|| !$v.formData.passwordRepeat.sameAsPassword )}"
            />
            <span class="form__row-pass-show" @click="showPassword()">
              {{ typePassword === 'password' ? 'Show' : 'Hide' }}
            </span>
          </div>
        </label>

        <div
          v-if="validationErrors.length"
          class="form-group"
        >
          <p
            v-for="(validationError, index) in validationErrors"
            :key="index"
            class="text-center form__error"
          >
            {{ validationError }}
          </p>
        </div>

        <button
          class="btn btn--color-dark form__button"
          :class="{ 'btn--loading': isLoading }"
        >
          <span v-if="!isLoading">Save Password</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import useResetPasswordSetting from '@/views/useResetPasswordSetting'
import {getHomeRouteForLoggedInUser, getUserData } from '@/auth/utils'
  export default {
    data() {
      return {
        formData: {
          password: null,
          passwordRepeat: null,
        },
        isLoading: false,
        validationErrors: [],
        typePassword: 'password',
      }
    },
    validations: {
      formData: {
        password: {
          required,
          minLength: minLength(6)
        },
        passwordRepeat: {
          required,
          minLength: minLength(6),
          sameAsPassword: sameAs('password'),
        },
      }
    },
    setup() {
      const {
        userPasswordChange,
      } = useResetPasswordSetting()

      return {
        userPasswordChange,
      }
    },
    methods: {
      showPassword() {
        this.typePassword = this.typePassword === 'password' ? 'text' : 'password'
      },
      async submitResetPasswordForm() {
        if (this.$v.$invalid){
          await this.$v.$touch()
          document.querySelector('.is-invalid').focus()
          this.errorMessage = 'All fields are required'
          return
        }

        this.isLoading = true

        const preparedData = {
          password: this.formData.password,
          password_confirmation: this.formData.passwordRepeat,
        }
        this.userPasswordChange(preparedData)
          .then(() => {
            this.$store.commit('SET_REQUIRE_RESET_PASSWORD', false)
            this.validationErrors = []
            this.$router.replace(getHomeRouteForLoggedInUser(getUserData().role))
          })
          .catch(error => {
            if (error.response.status === 422) {
              const validationErrors = Object.values(error.response.data.errors)
              this.validationErrors = validationErrors.flat()
            } else {
              console.log(error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>

<style>
</style>
